type ValidationResult =
  | { valid: true; normalizedUrl: string }
  | { valid: false; error: 'invalid_url' | 'protocol_not_allowed' }

export function validateUrl(input: string): ValidationResult {
  const trimmed = input.trim()

  // Empty or whitespace-only means "remove link"
  if (trimmed === '') {
    return { valid: true, normalizedUrl: '' }
  }

  // Auto-prepend https:// if no protocol (match both scheme:// and scheme:)
  const withProtocol = /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(trimmed)
    ? trimmed
    : `https://${trimmed}`

  let parsed: URL
  try {
    parsed = new URL(withProtocol)
  } catch {
    return { valid: false, error: 'invalid_url' }
  }

  // Only allow http and https
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    return { valid: false, error: 'protocol_not_allowed' }
  }

  // Valid hostname: alphanumeric labels separated by dots, no leading/trailing
  // dots or hyphens per label, requires at least one dot (TLD).
  //
  // Accepts:  example.com, sub.example.com, my-site.co.uk
  // Rejects:  -example.com, example-.com, .example.com,
  //           example.com., example..com, dsdfsdsd (no TLD)
  if (
    !/^([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(
      parsed.hostname
    )
  ) {
    return { valid: false, error: 'invalid_url' }
  }

  return { valid: true, normalizedUrl: withProtocol }
}
